import http from '@util/http';
import { hr } from '@api/req';

export async function queryHrWageList(params) {
  return http.get(hr.CORE_HR_WAGE_LIST, params);
}

/**
 * 工资
 */
export async function queryWageStatistic(params) {
  return http.get(hr.WAGE_STATISTIC, params);
}

export async function queryWageList(params) {
  return http.get(hr.GET_WAGE_LIST, params);
}

export async function queryWageMyList(params) {
  return http.get(hr.GET_WAGE_MY, params);
}

export async function queryMyWageCheckList(params) {
  return http.get(hr.GET_WAGE_CHECK, params);
}

export async function queryWageOrgRecord(params) {
  return http.get(hr.GET_WAGE_RECORD_ORG, params);
}

export async function queryWageInfo(params) {
  return http.get(hr.GET_WAGE_INFO, params);
}

export async function queryImportWage(params) {
  return http.post(hr.WAGE_IMPORT, params);
}

export async function querySaveWage(params) {
  return http.post(hr.WAGE_SAVE, params);
}

export async function queryDeleteWage(params) {
  return http.get(hr.WAGE_DELETE, params);
}

export async function queryNextWage(params) {
  return http.get(hr.WAGE_NEXT, params);
}

export async function queryReturnWage(params) {
  return http.post(hr.WAGE_RETURN, params);
}

export async function queryCallbackWage(params) {
  return http.get(hr.WAGE_CALLBACK, params);
}

export async function queryWageWorkflow(params) {
  return http.get(hr.WAGE_WORKFLOW, params);
}

export async function queryWageStaticComMonth(params) {
  return http.get(hr.WAGE_STATIC_C_M, params);
}

export async function queryWageDetailList(params) {
  return http.get(hr.WAGE_DETAIL_LIST, params);
}

export async function queryWageDetailInfo(params) {
  return http.get(hr.WAGE_DETAIL_INFO, params);
}

export async function querySendAllWage(params) {
  return http.get(hr.WAGE_SEND_ALL, params);
}

export async function querySendWage(params) {
  return http.get(hr.WAGE_SEND, params);
}

export async function queryBackAllWage(params) {
  return http.get(hr.WAGE_BACK_ALL, params);
}

export async function queryBackWage(params) {
  return http.get(hr.WAGE_BACK, params);
}

export async function queryDownloadWageTemplate() {
  http.download(hr.DOWNLOAD_WAGE_TEMPLATE, {}, '工资导入模板.xlsx');
}



// WEBPACK FOOTER //
// ./src/api/hr/wage.js